import React from "react";
import TokenBox from "../../TokenBox";

const Screen41 = () => {
  return <TokenBox />;
};

export default Screen41;
